import { useEffect } from 'react';
import {
  Box,
  RadioGroup,
  Radio,
  TableBody,
  TableRow,
  TableContainer,
} from '@mui/material';
import {
  StyledTableCellTwo,
  StyledTableCellWithoutLeftTwo,
  StyledTableCellWithoutLeftRightTwo,
} from 'routes/Main/style';
import SectionTitle from '../../components/SectionTitle';

import { IFormValues, IFormWatch } from 'routes/Main/type';

const radioId = ['no01', 'no02', 'no03', 'no04', 'no05'];

const 영역1 = [
  {
    id: 1,
    ko: '1. 활력징후',
    info: [
      '4가지 항목 (혈압, 맥박, 호흡수, 체온) 중 2가지 이상 측정',
      '수혈 시 측정하는 V/S는 제외',
    ],
    desc: [
      '해당 없음',
      '1점 : 1~3회',
      '2점 : 4~6회',
      '3점 : 7~9회',
      '4점 : 10회 이상',
    ],
  },
  {
    id: 2,
    ko: '2. 수분섭취 및 배설량 측정',
    info: ['섭취량, 배설량을 모두 측정 시 해당'],
    desc: ['해당 없음', '1점 : 1~2회', '2점 : 3회', '3점 : 4회 이상'],
  },
  {
    id: 3,
    ko: '3. 동공/의식/지남력',
    info: ['동공, 의식, 지남력 세 가지 모두 측정하여 check 4회 이상시 기록'],
    desc: ['해당 없음', '2점'],
  },
  {
    id: 4,
    ko: '4. 심전도 모니터링',
    info: ['근무조당 1회 이상 심전도 판독 내용을 기록한 경우 해당'],
    desc: ['해당 없음', '3점'],
  },
  {
    id: 5,
    ko: '5. 산소포화도',
    info: [
      '산소포화도 측정 후 기록한 경우만 해당',
      '계속적인 산소포화도 감시는 6회 이상에 포함',
    ],
    desc: ['해당 없음', '1점 : 3~5회', '2점 : 6회 이상'],
  },
];

const radioId1 = ['no06', 'no07', 'no08', 'no09'];

const 영역2 = [
  {
    id: 1,
    ko: '6. 산소요법',
    info: [''],
    desc: ['해당 없음', '2점'],
  },
  {
    id: 2,
    ko: '7. 흉부물리요법',
    info: ['타진, Vibrator 실시 후 기록한 경우'],
    desc: ['해당 없음', '1점 : 3~5회', '2점 : 6회 이상'],
  },
  {
    id: 3,
    ko: '8. 기관내 흡입 간호',
    info: ['T-cannula, E-tube를 통한 흡인 간호 시 해당', '구강 흡인은 제외'],
    desc: ['해당 없음', '2점 : 3~5회', '3점 : 6회 이상'],
  },
  {
    id: 4,
    ko: '9. 기관절개관 관리',
    info: ['T-cannula 교환 또는 dressing 등 시행'],
    desc: ['해당 없음', '2점'],
  },
];

interface Props extends IFormValues, IFormWatch {
  disabled?: boolean;
  sum1: number;
  setSum1: (sum1: number) => void;

  sum2: number;
  setSum2: (sum2: number) => void;
}
const KPCSCGWontents = (props: Props) => {
  const { disabled, setValue, getValues, setSum1, setSum2 } = props;

  const calculateSumValue1 = () => {
    setSum1(
      radioId.reduce((acc, cur) => {
        if (cur === 'no03') {
          const value = Number(getValues(cur)) * 2;
          return value ? acc + value : acc;
        } else if (cur === 'no04') {
          const value = Number(getValues(cur)) * 3;
          return value ? acc + value : acc;
        }
        const value = Number(getValues(cur));
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const handleChange1 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue1();
  };

  const calculateSumValue2 = () => {
    setSum2(
      radioId1.reduce((acc, cur) => {
        if (cur === 'no06' || cur === 'no09') {
          const value = Number(getValues(cur)) * 2;
          return value ? acc + value : acc;
        } else if (cur === 'no08' && Number(getValues(cur)) > 0) {
          const value = Number(getValues(cur)) + 1;
          return value ? acc + value : acc;
        }
        const value = Number(getValues(cur));
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const handleChange2 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue2();
  };

  useEffect(() => {
    calculateSumValue1();
    calculateSumValue2();
  }, []);

  return (
    <>
      <SectionTitle title="영역 : 활력징후 측정 및 감시" />
      <Box sx={{ width: '98%', margin: '20px' }}>
        <TableContainer sx={{ marginTop: '20px', marginBottom: '30px' }}>
          <TableBody>
            {영역1.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      verticalAlign: 'top',
                      borderBottom: 영역1.length - 1 === i ? 'none' : '',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo
                    sx={{
                      borderBottom: 영역1.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '45px' : '28px',
                      }}
                      name={radioId[content.id - 1]}
                      defaultValue={Number(getValues(radioId[content.id - 1]))}
                    >
                      {content.desc.map((point, i) => {
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '43px',
                              textAlign: 'center',
                            }}
                          >
                            <Box>
                              <Radio
                                disabled={disabled}
                                name={radioId[content.id - 1]}
                                value={i}
                                onChange={handleChange1}
                              />
                            </Box>
                          </TableRow>
                        );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{
                      borderBottom: 영역1.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '21px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '17px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{
                                  minWidth: '65vw',
                                  marginLeft: '-28px',
                                }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '8.5px',
                              }}
                            >
                              <Box
                                sx={{
                                  minWidth: '65vw',
                                  marginLeft: '-28px',
                                }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => (
                        <TableRow
                          sx={{
                            lineHeight: '42px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}>{v}</Box>
                        </TableRow>
                      ))}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>

        <SectionTitle title="영역 : 호흡" />
        <TableContainer sx={{ marginTop: '40px', marginBottom: '-30px' }}>
          <TableBody>
            {영역2.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      verticalAlign: 'top',
                      borderBottom: 영역2.length - 1 === i ? 'none' : '',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo
                    sx={{
                      borderBottom: 영역2.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '55px' : '28px',
                      }}
                      name={radioId1[content.id - 1]}
                      defaultValue={Number(getValues(radioId1[content.id - 1]))}
                    >
                      {content.desc.map((point, i) => {
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '43px',
                              textAlign: 'center',
                            }}
                          >
                            <Box>
                              <Radio
                                disabled={disabled}
                                name={radioId1[content.id - 1]}
                                value={i}
                                onChange={handleChange2}
                              />
                            </Box>
                          </TableRow>
                        );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{
                      borderBottom: 영역2.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '16px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '23px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '8.5px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => (
                        <TableRow
                          sx={{
                            lineHeight: '42px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}>{v}</Box>
                        </TableRow>
                      ))}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>
      </Box>
    </>
  );
};

export default KPCSCGWontents;
